import {
  ShippingRestrictionScope,
  DeliveryZonesScope,
  ProductRestrictionType,
  WeightRestrictionType,
  ValueRestrictionType,
} from '@tiendanube/common/src/enums';
import { ShippingRestrictionFormValues } from '../types';

export function hasAtLeastOneRule(
  values: ShippingRestrictionFormValues,
): boolean {
  const hasDistributionCenterRule =
    values.distributionCenterScope === ShippingRestrictionScope.SPECIFIC &&
    values.specificDistributionCenters &&
    values.specificDistributionCenters.length > 0;

  const hasGeographyRule =
    (values.deliveryZonesScope === DeliveryZonesScope.GEOGRAPHICAL_ZONE &&
      values.selectedZones &&
      values.selectedZones.length > 0) ||
    (values.deliveryZonesScope === DeliveryZonesScope.DISTANCE_IN_KM &&
      values.deliveryDistanceInKm &&
      values.deliveryDistanceInKm !== '0');

  const hasCategoryRule =
    values.productRestrictionType === ProductRestrictionType.CATEGORIES &&
    values.restrictedCategories &&
    values.restrictedCategories.length > 0;

  const hasProductRule =
    values.productRestrictionType === ProductRestrictionType.PRODUCTS &&
    values.restrictedProducts &&
    values.restrictedProducts.length > 0;

  const hasWeightRule =
    values.weightRestrictionType === WeightRestrictionType.WEIGHT_RANGE &&
    ((values.cartWeightMin && values.cartWeightMin !== '0') ||
      (values.cartWeightMax && values.cartWeightMax !== '0'));

  const hasValueRule =
    values.valueRestrictionType === ValueRestrictionType.VALUE_RANGE &&
    ((values.cartValueMin && values.cartValueMin !== '0') ||
      (values.cartValueMax && values.cartValueMax !== '0'));

  return Boolean(
    hasDistributionCenterRule ||
      hasGeographyRule ||
      hasCategoryRule ||
      hasProductRule ||
      hasWeightRule ||
      hasValueRule,
  );
}
